import angular from 'angular';
import fileUploader from 'angular-file-upload';

import storageService from '../../services/storage.service.js';

import storageListController from './storageList.controller.js';
import storageListItemController from './storageListItem.controller.js';
import storageUploadController from './storageUpload.controller.js';
import storageUploadModalController from './storageUploadModal.controller.js';
import storageDeleteController from './storageDelete.controller.js';
import storageDeleteModalController from './storageDeleteModal.controller.js';

export default angular.module('components.storage', [
    storageService,
    'angularFileUpload'
])
    .component('storageDisplayStatus', {
        bindings: {
            status: '<'
        },
        template: require('./storageDisplayStatus.pug')()
    })
    .component('storageList', {
        template: require('./storageList.pug')(),
        bindings: {
            database: '<'
        },
        controller: storageListController
    })
    .component('storageListItem', {
        template: require('./storageListItem.pug')(),
        bindings: {
            item: '<'
        },
        controller: storageListItemController
    })
    .component('storageUpload', {
        template: require('./storageUpload.pug')(),
        bindings: {
            text: '@',
            title: '@',
            database: '<',
            onDone: '&'
        },
        controller: storageUploadController
    })
    .component('storageUploadModal', {
        template: require('./storageUploadModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: storageUploadModalController
    })
    .component('storageDelete', {
        template: require('./storageDelete.pug')(),
        bindings: {
            content: '<',
            text: '@',
            title: '@',
            disabled: '<',
            onDone: '&'
        },
        controller: storageDeleteController
    })
    .component('storageDeleteModal', {
        template: require('./storageDeleteModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: storageDeleteModalController
    })
    .name;
